import { environment } from '../../../environments/environment';

export const anneeScolaireFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_annee_scolaire'])
            }
        };
    },
    resMapper: (data) => {
        return [ ...data.map((option) => { // {value: null, label: 'Pas de xxx'},
            return {
                value: parseInt(option.id),
                label: option.libelle,
            };
        })];
    }
};

export const evaluationFetchOptions = {
    url: environment.proxyUrl + '/examen/searchExamenAnneeScolaire',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify([true, values.anneeScolaire, values.isExamen, !values.isExamen])
            }
        };
    },
    resMapper: (data) => {
        return data instanceof Array ? data.map((option) => {
            return {
                value: option.id,
                label: option.libelle,
            };
        }) : [];
    },
    selectedIndex: 0,
};

export const disciplineEvaluationFetchOptions = {
    url: environment.proxyUrl + '/discipline/findByExamen',
    httpOptions: (values) => {
        // console.log({values});
        return {
            params: {
                'params': JSON.stringify([values.anneeScolaire, values.examenId, values.isExamen])
            }
        };
    },
    resMapper: (data) => {
        return data.map((option) => {
            return {
                value: option.id,
                label: option.libelle,
            };
        });
    }
};

export const disciplineFetchOptions = {
    url: environment.proxyUrl + '/discipline/searchByCriteria', // findAll',
    httpOptions: (values) => {
        values.isOnlyActivated = true;
        // console.log('httpOptions', values);
        return {
            params: {
                'params': JSON.stringify([values])
            }
        };
    },
    resMapper: (data) => {
        return [{value: null, label: 'Toutes les disciplines'}, ...data.map((option) => {
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};

export const cursusFetchOptions = {
    url: environment.proxyUrl + '/cursus/findAllCursusActif',
    httpOptions: (values) => {
        // console.log('httpOptions', values);
        return {
            params: {
                'params': JSON.stringify([])
            }
        };
    },
    resMapper: (data) => {
        return [{value: null, label: ''}, ...data.map((option) => {
            return {
                value: option.id,
                label: option.nom,
            };
        })];
    }
};

export const professeurFetchOptionsFactory = function(defaultValue) {
    return {
        url: environment.proxyUrl + '/professeur/findAll',
        httpOptions: (values) => {
            // console.log('httpOptions', values);
            return {
                params: {
                    'params': JSON.stringify([])
                }
            };
        },
        resMapper: (data) => {
            return [defaultValue, ...data.map((option) => {
                return {
                    value: option.id,
                    label: `${option.prenom} ${option.nom}`,
                };
            })];
        }
    };
};

export const professeurFetchOptions = {
    url: environment.proxyUrl + '/professeur/searchByCriteria', // findAll
    httpOptions: (values) => {
        // console.log('httpOptions', values);
        return {
            params: {
                'params': JSON.stringify([values])
            }
        };
    },
    resMapper: (data) => {
        // console.log('professeurFetchOptions resMapper');
        return [{value: null, label: 'Tous les professeurs'}, ...data.map((option) => {
            return {
                value: option.id,
                label: `${option.nom ? option.nom : ''} ${option.prenom ? option.prenom : ''}`,
            };
        })];
    }
};


export const salleFetchOptions = {
    url: environment.proxyUrl + '/salle/searchByCriteria',
    httpOptions: (values) => {
        // console.log('httpOptions', values);
        const criteriaActivated = {
            isOnlyActivated: true,
        };
        return {
            params: {
                'params': JSON.stringify([criteriaActivated])
            }
        };
    },
    resMapper: (data) => {
        return [{value: null, label: 'Toutes les salles'}, ...data.map((salle) => {
            return {
                'value': salle.id,
                'label': salle.nom
            };
        })];
    }
};

export const niveauFetchOptions = {
    url: environment.proxyUrl + '/niveau/findAllNiveaux',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify([])
            }
        };
    },
    resMapper: (data) => {
        return [{value: null, label: 'Tous les niveaux'}, ...data.map((option) => {
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};


export const cycleFetchOptions = {
    url: environment.proxyUrl + '/niveau/findAllCycles',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify([])
            }
        };
    },
    resMapper: (data) => {
        return [{value: null, label: 'Tous les cycles'}, ...data.map((option) => {
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};


export const civiliteFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_civilite'])
            }
        };
    },
    resMapper: (data) => {
        return [...data.map((option) => { // {value: null, label: 'Pas de civilité'},
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};

export const lienParenteFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_parente'])
            }
        };
    },
    resMapper: (data) => {
        return [...data.map((option) => { // {value: null, label: 'Pas de civilité'},
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};

export const trancheQFFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        console.log({values});
        return {
            params: {
                'params': JSON.stringify(['ref_tranche_quotient_familial', values.anneeScolaire])
            }
        };
    },
    resMapper: (data) => {
        return [ {value: null, label: 'Pas de tranche QF'}, ...data.map((option) => { // {value: null, label: 'Pas de civilité'},
            return {
                value: option.id,
                label: option.libelle,
            };
        })];
    }
};

export const modePaimentFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        console.log({values});
        return {
            params: {
                'params': JSON.stringify(['ref_type_paiement'])
            }
        };
    },
    resMapper: (data) => {
        return [ {value: null, label: 'Pas de mode de paiement'}, ...data.map((option) => {
            return {
                value: option.id, // .id,
                label: option.libelle,
            };
        })];
    },
};

export const periodeExamenFetchOptions = {
    url: environment.proxyUrl + '/examen/searchGroupesExamens',
    httpOptions: (values) => {
        console.log('searchGroupesExamens', {values});
        return {
            params: {
                'params': JSON.stringify([])
            }
        };
    },
    resMapper: (data) => {
        console.log('periodes examens', data);
        return [ ...data.map((option) => {
            return {
                value: parseInt(option.id),
                label: option.libelle,
            };
        })];
    },
    selectedIndex: 0,
};

// Pour l'utiliser il faut passer l'année scolaire :
// this.http.get(
//      inscriptionActionFetchOptions.url,
//      {params: {'params': JSON.stringify(['ref_inscription_action', anneeScolaire]),}})
// .subscribe((inscriptionAction) => {
//      const options = inscriptionActionFetchOptions.resMapper(inscriptionAction);
//      this.model.registerEntryDynamicProperty(['create'], 'inscriptionAction', 'default', options[0].value);
//      this.model.registerEntryDynamicProperty(['create'], 'inscriptionAction', 'options', options);
// });
// }
export const inscriptionActionFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_inscription_action'])
            }
        };
    },
    resMapper: (data) => {
        return [ ...data.map((option) => { // {value: null, label: 'Pas de xxx'},
            return {
                value: parseInt(option.id),
                label: option.libelle,
            };
        })];
    }
};

export const statutEleveFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_statut_eleve'])
            }
        };
    },
    resMapper: (data) => {
        return [{ value: null, label: 'Tous' }, { value: -1, label: 'Pas de statut' }, ...data.map((option) => { // {value: null, label: 'Pas de xxx'},
            return {
                value: parseInt(option.id), // as string, // forcé à string // parseInt(option.id),
                label: option.libelle,
            };
        })];
    }
};

export const niveauScolaireFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_niveau_scolaire'])
            }
        };
    },
    resMapper: (data) => {
        return [{ value: null, label: 'Tous' }, ...data.map((option) => { // {value: null, label: 'Pas de xxx'},
            return {
                value: parseInt(option.id),
                label: option.libelle,
            };
        })];
    }
};

export const statutInstrumentPretFetchOptions = {
    url: environment.proxyUrl + '/reference/getReferenceObjects',
    httpOptions: (values) => {
        return {
            params: {
                'params': JSON.stringify(['ref_statut_instr'])
            }
        };
    },
    resMapper: (data) => {
        return [{ value: null, label: '' }, ...data.map((option) => { // {value: null, label: 'Pas de xxx'},
            return {
                value: +parseInt(option.id), // as string, // forcé à string // parseInt(option.id),
                label: option.libelle,
            };
        })];
    }
};


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/resource/select-options.ts